import React, { useCallback } from 'react';
import { ReportType } from '~/components/Admin';
import { ServicesContext } from '~/services';
import { convertPagination, defaultApiResponseHandler } from '~/util';

export interface GetReportsParamsType {
    page?: null | number;
    items_per_page?: null | number;
}
export const useGetReports = () => {
    const services = React.useContext(ServicesContext);

    const getReports = useCallback(
        async (params: GetReportsParamsType) => {
            try {
                const result = await services.api.call({
                    method: 'get',
                    url: '/api/reports',
                    params,
                    data: {},
                    headers: {
                        'Content-Type': 'application/ld+json',
                    },
                });
                return {
                    results: result.data['hydra:member'] as ReportType[],
                    pagination: convertPagination(result.data),
                };
            } catch (error) {
                throw defaultApiResponseHandler(error);
            }
        },
        [services.api]
    );

    return getReports;
};
